/**
 * 获取权限界面的模拟后台接口数据
 */
export function getAuthorityDataInit() {
    return [{
        name: "系统设置", // 父模块
        id: "",
        corKey: "systemSetting",
        purview: 0,
        children: [{
            name: "部门设置", // 子模块
            corKey: "departmentSetting",
            id: "",
            purview: 0,
            children: [{
                    id: "",
                    name: "编辑", // 功能名称
                    corKey: "edit_depart", // 功能对应key
                    purview: 0 // 当前功能对应权限  0 可见  1 不可见
                },
                { id: "", name: "添加子部门", corKey: "add_depart_childer", purview: 0 },
                { id: "", name: "设置上级", corKey: "set_lead", purview: 0 },
                { id: "", name: "删除部门", corKey: "delete_depart", purview: 0 },
                { id: "", name: "上移", corKey: "depart_move_up", purview: 0 },
                { id: "", name: "下移", corKey: "depart_move_down", purview: 0 },
            ]
        }, {
            name: "标签设置", // 子模块
            corKey: "tagSetting",
            id: "",
            purview: 0,
            children: [
                { id: "", name: "编辑标签", corKey: "edit_tag", purview: 0 },
                { id: "", name: "添加标签", corKey: "add_tag", purview: 0 },
                { id: "", name: "删除标签", corKey: "delete_tag", purview: 0 },
            ]
        }]
    }, {
        name: "题库设置",
        id: "",
        corKey: "questionSetting",
        purview: 0,
        children: []
    }, {
        name: "试卷设置",
        id: "",
        corKey: "parperSetting",
        purview: 1,
        children: []
    }, {
        name: "考试设置",
        id: "",
        corKey: "eaxmSetting",
        purview: 1,
        children: []
    }]
}

/**
 * 对接口拿到的权限数据进行处理
 * @param {*} array  接口返回的权限数据
 */
export function processorAuthorityData(array) {
    array.forEach(element => {
        element.purview = element.purview == 0
        element.children.forEach(ele => {
            ele.purview = ele.purview == 0
            ele.children.forEach(e => {
                e.purview = e.purview == 0
            });
        });
    });
    return array
}

/**
 * 权限全选
 * @param {*} array 
 */
export function checkAuthorityData(array) {
    array.forEach(element => {
        element.purview = true
        element.children.forEach(ele => {
            ele.purview = true
            ele.children.forEach(e => {
                e.purview = true
            });
        });
    });
    return array
}

/**
 * 对界面修改后的权限数据进行处理,返回接口需要的数据
 * @param {*} array  界面处理后的权限数据
 */
export function processorAuthorityDataForInterface(array) {
    console.log("所有权限", array);
    array.forEach(element => {
        element.purview = element.purview ? element.purview = 0 : element.purview = 1
        element.children.forEach(ele => {
            ele.purview = ele.purview ? ele.purview = 0 : ele.purview = 1
            ele.children.forEach(e => {
                e.purview = e.purview ? e.purview = 0 : e.purview = 1
            });
        });
    });
    return array
}

/**
 * 获取部门学员树的模拟数据
 */
export function getInitDepartUserTreeData() {
    return [{
            label: "一级 1",
            children: [{
                label: "二级 1-1",
                children: [{
                    label: "三级 1-1-1",
                    children: [],
                }, ],
            }, ],
        },
        {
            label: "一级 2",
            children: [{
                    label: "二级 2-1",
                    children: [{
                        label: "三级 2-1-1",
                    }, ],
                },
                {
                    label: "二级 2-2",
                    children: [{
                        label: "三级 2-2-1",
                    }, ],
                },
            ],
        },
        {
            label: "一级 3",
            children: [{
                    label: "二级 3-1",
                    children: [{
                        label: "三级 3-1-1",
                    }, ],
                },
                {
                    label: "二级 3-2",
                    children: [{
                        label: "三级 3-2-1",
                    }, ],
                },
            ],
        },
        {
            label: "一级 3",
            children: [{
                    label: "二级 3-1",
                    children: [{
                        label: "三级 3-1-1",
                    }, ],
                },
                {
                    label: "二级 3-2",
                    children: [{
                        label: "三级 3-2-1",
                    }, ],
                },
            ],
        },
    ]
}